module.exports = __webpack_public_path__ + "img/contact_bg.c34178a3.jpg";